var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMenuIcon8 = function SvgMenuIcon8(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_810_15671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4999 6.89688L23.2906 4.6875L18.9265 9.05156L16.4484 6.57344L20.8124 2.20938L18.6031 0L14.239 4.36406L11.4374 1.5625L9.32181 3.67656L21.8218 16.1766L23.9374 14.0625L21.1359 11.2609L25.4999 6.89688ZM19.8859 16.45L9.04994 5.61406C6.71088 8.41875 4.05619 12.7547 5.89056 16.4844L2.66244 19.7125C2.29757 20.0796 2.09277 20.5762 2.09277 21.0938C2.09277 21.6113 2.29757 22.1079 2.66244 22.475L3.02494 22.8375C3.39204 23.2024 3.8886 23.4072 4.40619 23.4072C4.92377 23.4072 5.42033 23.2024 5.78744 22.8375L9.01556 19.6094C12.7452 21.4438 17.0796 18.7906 19.8859 16.45Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_810_15671"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(0.5)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMenuIcon8);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "menu-icon-8.8dc3b31b602539f8a2a373ed35e589a6.svg";